module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_men_hairmake-1f75a9c3870688d4bfb012805c30a1b4.jpg";